var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChervonLeft = function SvgChervonLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.705 10.59 3.125 6l4.58-4.59L6.295 0l-6 6 6 6z"
  })));
};
export default SvgChervonLeft;